<template>
  <div id="app">
    <!-- Top navigation bar -->
    <navbar v-if="userLoggedIn.category" :key="navbarKey"/>
    <notification-bubble v-if="showNotificationBubble && userLoggedIn" ref="notificationBubble" />
    <div class="d-flex justify-content-center position-fixed w-100" style="z-index: 1; margin-top: 10px">
      <div v-if="getIsPlatformClosed && $route.meta.style !== 'login'" class="alert bg-t_grey text-white mx-auto shadow " role="alert">
        <i class="fas fa-info-circle mr-2"></i>Offers are currently disabled across the platform. You can still view Orders, Reports and other pages on the platform.
      </div>
    </div>
    <div 
      class="container-fluid"
      :class="[{'general-container' : $route.meta.style !== 'login', 'px-0' : $breakpoint.lgAndDown}, { 'pt-4' : getIsPlatformClosed}]"
    >     
      <router-view name="TermsAndConditions"></router-view>
      <router-view name="MyAccount"></router-view>
      
      <router-view v-if="userLoggedIn.category ==='buyer'" name="buyerDashboard"></router-view>
      <router-view v-if="userLoggedIn.category ==='buyer'" name="AllPrices"></router-view>
      <router-view v-if="userLoggedIn.category ==='buyer'" name="ExistingContracts"></router-view>
      <router-view v-if="userLoggedIn.category ==='buyer'" name="OlfChat"></router-view>
      <router-view v-if="userLoggedIn.category ==='buyer'" name="PurchaseHistory"></router-view>
      <router-view v-if="userLoggedIn.category ==='buyer'" name="MySuppliers"></router-view>

        <!-- <notification-panel class="notification-panel-container"/>
        <notification-panel-icon class="notification-panel-icon"/> -->
      
      <router-view v-if="userLoggedIn.category === 'seller'" name="sellerDashboard"></router-view>
      <router-view v-if="userLoggedIn.category === 'seller'" name="manageProducts"></router-view>
      <router-view v-if="userLoggedIn.category === 'seller'" name="OlfChat"></router-view>
      <router-view v-if="userLoggedIn.category === 'seller'" name="MyCustomers"></router-view>
      <router-view v-if="userLoggedIn.category === 'seller'" name="PurchaseHistory"></router-view>
      <router-view v-if="userLoggedIn.category === 'seller'" name="OrderCapture"></router-view>
      <router-view v-if="userLoggedIn.category === 'seller'" name="PricingEngine"></router-view>

      <action-confirmation v-if="showActionConfirmation && userLoggedIn" ref="actionConfirmation" />

    </div>

    <help-panel v-if="userLoggedIn.category" ref="helpPanel" />

    <start-conversation v-if="searchModal" ref="startConversation"/>
        
    <offer-modal v-if="showSpotModal || showContractModal" ref="offerModal" />

    <confirmation-remove-item v-if="showItemRemovalConfirmation" ref="confirmationRemoveItem"
      :itemToRemove="itemToRemove" :itemType="itemToRemoveType" />
    
    <upload-matrix v-if="showUploadMatrix" ref="uploadMatrix"/>

    <!-- Decide whether to show Daily Settlement/Global Pricing Rules -->
    <template v-if="showDailyPriceModal && userLoggedIn">
      <pricing-rules-daily-prices ref="dailyPrices" />
    </template>

    <select-favourites v-if="selectFavouritesModal" ref="selectFavourites" />

    <confirmation-logout v-if="showConfirmationLogout" ref="confirmationLogout"/>
    <confirmation-remove-favourite v-if="showConfirmationRemoveFavourite" ref="confirmationRemoveFavourite" />

    <router-view name="login"></router-view>
    <router-view name="requestNewPassword"></router-view>
    <router-view name="resetPassword"></router-view>
    <router-view name="logoutSuccessful"></router-view>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

import Navbar from "@/components/Navigation/Navbar.vue";
import NotificationBubble from '@/components/NotificationsTool/NotificationBubble.vue'
import ActionConfirmation from '@/components/NotificationsTool/ActionConfirmation.vue'

/* Modals */
import OfferModal from "@/modals/OfferModal.vue";
import ConfirmationLogout from "@/modals/ConfirmationLogout.vue";
import SelectFavourites from "@/modals/SelectFavourites.vue";
import StartConversation from "@/components/ChatService/StartConversation.vue";
import PricingRulesDailyPrices from"@/modals/DailyPrices/PricingRulesDailyPrices.vue";
import UploadMatrix from "@/modals/UploadMatrix.vue";
import ConfirmationRemoveFavourite from '@/modals/ConfirmationRemoveFavourite.vue';
import ConfirmationRemoveItem from '@/modals/ConfirmationRemoveItem.vue';
import HelpPanel from '@/components/HelpPanel.vue';

import breakpoint from '@/mixins/index';

export default {
  mixins: [breakpoint],
  components: {
    Navbar,
    StartConversation,
    ConfirmationLogout,
    SelectFavourites,
    PricingRulesDailyPrices,
    UploadMatrix,
    ConfirmationRemoveFavourite,
    NotificationBubble,
    OfferModal,
    ActionConfirmation,
    ConfirmationRemoveItem,
    HelpPanel,
  },
  data() {
    return {
      showSidemenu: true,
      navbarKey: 0,
    };
  },
  computed: {
    ...mapGetters('buyerOpen', ['getIsPlatformClosed']),
    ...mapGetters("login", ["isPricingEngineEnabled"]),
    ...mapState('itemRemoval', ['showItemRemovalConfirmation', 'itemToRemove', 'itemToRemoveType']),
    ...mapState("conversation", ['searchModal']),
    ...mapState("login", ["userLoggedIn", 'showConfirmationLogout']),
    ...mapState('notifications', ['showNotificationBubble', 'showActionConfirmation']),
    ...mapState('sellerOffers',['showSpotModal','showContractModal', 'showUploadMatrix']),
    ...mapState("selectFavourites", ["selectFavouritesModal",'showConfirmationRemoveFavourite']),
    ...mapState('livePrices',['showDailyPriceModal']),
    displayNotificationBubble: function(){
      if (this.showNotificationBubble){
        setTimeout(() => {
          $('.notification-toast').toast('show')
        }, 1000)
      }
    },
    openModals(){
      if(this.showDailyPriceModal){
        setTimeout(()=>{
          const element = this.$root.$refs.dailyPrices.$el
          $(element).modal({backdrop: 'static', keyboard: false})
        },500)
      }
      return
    },
    isGreenBsp() {
      return process.env.VUE_APP_Platform === "Greenergy";
    }
  },
  watch: {
    displayNotificationBubble(){},
    openModals(){},
  },
  methods: {
    ...mapActions("conversation", ["showSearchModal"]),
    ...mapActions("fuelsType",["getFuelsList"]),
    ...mapActions('terminals', ['getTerminals']),
  },
}
</script>
